export const PAGE_TYPES = {
    QUOTE_GRID: 'QUOTE_GRID',
    QUOTE_SUBMISSION: 'QUOTE_SUBMISSION',
};

export const QUOTE_LINE_SELECTED_STATES = {
    LOCKED: 'LOCKED',
    IGNORE: 'IGNORE',
    SEND_PARTIAL: 'SEND_PARTIAL',
    SELECT: 'SELECT',
    NO_QUOTE: 'NO_QUOTE',
};

export const QUOTE_LINE_PROCESSED_STATUSES = {
    REQUESTED: 'REQUESTED',
    PROCESSED: 'PROCESSED',
    RESPONDED: 'RESPONDED',
};

export const STOCK_CHECK_STATUSES = {
    IN_PROCESS: 'In Process',
    COMPLETED: 'Completed',
};

export const QUOTE_TYPES = {
    OUTRIGHT: 'Outright',
    EXCHANGE: 'Exchange',
};

export const defaultCommentData = {
    quoteLineId: '',
    comments: '',
    open: false,
};

export const CONDITION_CODES = {
    NULL: 'NULL',
    NS: 'NS',
    NE: 'NE',
    OH: 'OH',
    SV: 'SV',
    AR: 'AR',
};

export const aeroxchangeSource = 'AeroXchange';

export const skyselectSource = 'SkySelect';
